/**
 * sl-728o.7.3: Tutorial Sessions Registration Hook
 *
 * Registers the tutorial sessions that have live, reachable UI targets.
 * Called from workspace-layout.tsx WorkspaceLayoutInner.
 */
import { useI18n } from '@affine/i18n';
import { useService } from '@toeverything/infra';
import { useEffect } from 'react';

import { TutorialRegistry } from '../../services/tutorial-registry';
import { createAiChatSession } from './ai-chat';
import { createDatabaseBasicsSession } from './database-basics';
import { createKanbanViewSession } from './kanban-view';
import { createModerationSession } from './moderation';
import { createPresentationSession } from './presentation';

export function useRegisterTutorialSessions(): void {
  const registry = useService(TutorialRegistry);
  const t = useI18n();

  useEffect(() => {
    const sessions = [
      createDatabaseBasicsSession(t),
      createAiChatSession(t),
      createKanbanViewSession(t),
      createPresentationSession(t),
      createModerationSession(t),
    ];

    for (const session of sessions) {
      registry.register(session);
    }

    return () => {
      for (const session of sessions) {
        registry.unregister(session.id);
      }
    };
  }, [registry, t]);
}
